import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Utility to format wallet address
export function formatAddress(address) {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

// Utility to format ETH amounts
export function formatETH(amount, decimals = 4) {
    if (amount === null || amount === undefined) return '0';
    return parseFloat(amount).toFixed(decimals);
}
